( function () {
    'use strict';
    e.ecom = {};
    jQuery( function () {
        e.ecom.productgrid.init();
        e.ecom.productlist.init();
        e.ecom.productdetails.init();
        e.ecom.checkout.init();
        e.ecom.quick.init();
        e.ecom.multi.init();
        e.ecom.inpageModalCart.init();
    } );
}() );
